import React from "react";
import { createRoot } from "react-dom/client";
import {HashRouter, Navigate, Route, Routes} from "react-router-dom";
import UserContext from './usercontext.jsx';
import Towers from './towers.jsx';
import Users from './users.jsx';
import UploadForm from './uploadform.jsx';
import MainMenu from './mainmenu.jsx';
import ChecklistPage from './checklistpage.jsx';
import SoftwareVersions from './softwareversion.jsx';
import Header from './header.jsx';
import Synchronization from './synchronization'
import {StyledEngineProvider} from "@mui/material";


class Home extends React.Component {

    render() {
        return (
            <UserContext.Consumer>
                {user => (
                    <div>
                        { user.auth ? (
                            <p>
                            Welcome to Central Server. You have successfully logged in.
                            </p>
                        ) : (
                            <div>
                                <h4>You are not logged in! Please log in to continue.</h4>
                                <button id="btn-login" className="btn btn-danger btn-margin" onClick={user.login}>
                                    Log In
                                </button>
                            </div>
                        )}
                    </div>
                )}
            </UserContext.Consumer>
        )
    }
}




class App extends React.Component {

    constructor(props) {
        super(props);
        this.state = { height: (window.innerHeight - 90) };
        this.updateHeight = this.updateHeight.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateHeight);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateHeight);
    }

    updateHeight() {
        this.setState({ height: (window.innerHeight - 90) });
    }

    render() {
        var user = getAuth();
        if (user.auth) {
            return (
                <UserContext.Provider value={user}>
                    <div>
                        <Header/>
                        <div style={{ position: 'fixed', width: 300, zIndex: 100, top: 90, display: 'flex', height: this.state.height, flexDirection: 'column'}}>
                            <MainMenu/>
                            <div style={{padding: 15, fontSize: '0.7em'}}>
                                Version: {process.env.SERVER_VERSION}
                            </div>
                        </div>
                        <div id="home-view" style={{ position: 'relative', marginLeft: 300, zIndex: 1, top: 90, minHeight: this.state.height, padding: 30, background: '#f7f7f7', borderLeft: '2px solid #dfdfdf' }}>
                                 <Routes>
                                        <Route path="/" element={<Navigate to="/towers" replace />} />
                                        <Route path='/towers' element={<Towers />}/>
                                        <Route path='/users' element={<Users />}/>
                                        <Route path='/upload' element={<UploadForm />}/>
                                        <Route path='/checklists' element={<ChecklistPage />}/>
                                        <Route path='/software' element={<SoftwareVersions />}/>
                                        <Route path='/synchronization' element={<Synchronization />}/>
                                    </Routes>

                        </div>
                    </div>
                </UserContext.Provider>
            );
        } else {
            if (user.error) {
                return (
                    <div style={{border: '2px solid #dfdfdf', padding: 30 }}>
                        Error: {user.error.error} <br/>
                        {user.error.errorDescription}
                    </div>
                );
            } else {
                return (<div/>);
            }
        }
    }
}

const root = createRoot(document.getElementById('react'));
root.render(<StyledEngineProvider injectFirst><HashRouter><App /></HashRouter></StyledEngineProvider>);
